import styled from '../../../utils/styled';

export const StatisticContainer = styled('div')`
    display: flex;
`;
